// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__XBad-","inputDescription":"styles_inputDescription__3EXif"};